import React, {Component} from 'react'

class NewsForm extends Component {
    render() {
        return (
            <div>
                This is form for news board
            </div>
        )
    }
}

export default NewsForm
